import React, { useContext, useEffect, useRef, useState } from 'react';
import { AuthContextAdmin } from '../context/AuthContextAdmin';
import { Col, Container, Row } from 'react-bootstrap';
import { Navigate } from 'react-router-dom';
import { Toaster, toast } from 'react-hot-toast';

const LoginComponentAdmin = () => {
  const { adminLogin, error, isAuthenticated, clearError } =
    useContext(AuthContextAdmin);
  const [password, setPassword] = useState('');
  const [isInvalid, setIsInvalid] = useState(false);
  const focusInputRef = useRef(null);

  useEffect(() => {
    focusInputRef.current.focus();
  }, []);

  useEffect(() => {
    if (error) {
      toast.error(error);
      setIsInvalid(true);
      focusInputRef.current.focus();
    }
  }, [error]);

  const handleLogin = async (event) => {
    event.preventDefault();
    clearError(); // Clear any previous errors
    if (!password) {
      setIsInvalid(true);
      toast.error('Please enter the password');
      focusInputRef.current.focus();
    } else {
      setIsInvalid(false);
      try {
        focusInputRef.current.blur();
        await adminLogin(password); // Wait for the login attempt to complete
      } catch (err) {
        // Error handling is now done via the useEffect that watches the error state
        focusInputRef.current.focus();
      }
    }
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    setIsInvalid(false);
  };

  if (isAuthenticated) {
    return <Navigate to="/settings" />;
  }

  return (
    <Container fluid>
      <Row>
        <Toaster />
        <Col
          className="text-center"
          style={{
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <div className="p-2">
            <h6 className="h5">Admin Log In</h6>
          </div>
          <form onSubmit={handleLogin} autoComplete="off" data-bwignore="true">
            <div className="form-floating mb-3">
              <input
                id="admin-password"
                name="admin-password"
                className={`form-control ${isInvalid ? 'is-invalid' : ''}`}
                type="password"
                autoComplete="off"
                data-bwignore="true"
                placeholder="Password"
                value={password}
                ref={focusInputRef}
                onChange={handlePasswordChange}
              />
              <label htmlFor="admin-password">Password</label>
            </div>
            <button type="submit" className="btn btn-primary">
              Sign in
            </button>
          </form>
        </Col>
      </Row>
    </Container>
  );
};

export default LoginComponentAdmin;
